import { Map as ImmMap } from 'immutable';
import {
	TOGGLE_MAIN_DRAWER,
	CLOSE_MAIN_DRAWER,
	TOGGLE_CART_DRAWER,
	CLOSE_CART_DRAWER,
	SHOW_CHIP,
	DELETE_CHIP,
} from './constants';

export const initialState = new ImmMap({
	isMainDrawerOpen: false,
	isCartDrawerOpen: false,
	chipText: '',
	isChipVisible: false,
});

const navBarReducer = (state = initialState, action) => {
	switch (action.type) {
		case TOGGLE_MAIN_DRAWER:
			return state.merge({
				isMainDrawerOpen: !state.get('isMainDrawerOpen'),
			});
		case CLOSE_MAIN_DRAWER:
			return state.merge({
				isMainDrawerOpen: false,
			});
		case TOGGLE_CART_DRAWER:
			return state.merge({
				isCartDrawerOpen: !state.get('isCartDrawerOpen'),
			});
		case CLOSE_CART_DRAWER:
			return state.merge({
				isCartDrawerOpen: false,
			});
		case SHOW_CHIP:
			return state.merge({ isChipVisible: true, chipText: action.chipText });
		case DELETE_CHIP:
			return state.merge({ isChipVisible: false, chipText: '' });
		default:
			return state;
	}
};

export default navBarReducer;
